import moment from 'moment'

export const customerComplaintVerification = {
  id: '',
  distributedToInternal: moment().format('YYYY-MM-DD'),
  receivedDate: moment().format('YYYY-MM-DD'),
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  phone: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  ownerMemberId: '',
  ownerMemberName: '',
  ownerMemberEmail: '',
  happenedBefore: false,
  action: '',
  comment: '',
  createdBy: '',
  updatedBy: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintVerificationDetail = {
  id: '',
  customerComplaintId: '',
  question: '',
  memberId: '',
  responder: '',
  email: '',
  attachment: '',
  answeredAt: '',
}

export const customerComplaintDetail = {
  customerComplaintId: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
}

export const customerComplaintQuestion = {
  id: '',
  customerComplaintId: '',
  question: '',
  answer: '',
  answeredAt: moment().format('YYYY-MM-DD'),
  needAttachment: 0,
  attachment: '',
}